var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMessage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M13.5416609,1 L2.45834018,1 C1.65292584,1 1.00000852,1.6671275 1.00000852,2.49007098 L1.00000852,14.6997126 C0.999158493,14.8136747 1.06199226,14.9181533 1.16187857,14.9688664 C1.26176489,15.0195796 1.38121101,15.0076462 1.46959131,14.9381239 L4.71292094,12.3889105 C4.76340727,12.3502217 4.82481284,12.3293077 4.88792074,12.3293077 L13.5416609,12.3293077 C13.9292444,12.3293097 14.3008857,12.1716662 14.5745105,11.8911915 C14.8481353,11.6107169 15.0012328,11.2304854 14.9999925,10.8344685 L14.9999925,2.49007098 C14.9999925,2.09487958 14.8463473,1.7158742 14.5728571,1.43643169 C14.2993668,1.15698917 13.9284345,1 13.5416609,1 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessage);
export default __webpack_public_path__ + "static/media/message.fbb7c75744c11a2569122a2adfcde4ec.svg";
export { ForwardRef as ReactComponent };